import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { SELECT_POST_MALONE_SAVED_TEMPLATE_MUTATION } from './selectPostMaloneSavedTemplate.mutation';
import {
  SelectPostMaloneSavedTemplateMutation,
  SelectPostMaloneSavedTemplateMutationVariables
} from './__generated__/SelectPostMaloneSavedTemplateMutation';

export const useSelectPostMaloneSavedTemplate = () => {
  return useMutation<SelectPostMaloneSavedTemplateMutation, SelectPostMaloneSavedTemplateMutationVariables>(
    SELECT_POST_MALONE_SAVED_TEMPLATE_MUTATION,
    { client: kmsClient }
  );
};
